










































import { defineComponent, PropType } from '@vue/composition-api'

export default defineComponent({
  name: 'Input',
  props: {
    label: {
      type: String as PropType<string>,
      default: ''
    },
    required: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    type: {
      type: String as PropType<string>,
      default: 'text'
    },
    size: {
      type: String as PropType<string>,
      default: 'md'
    },
    placeholder: {
      type: String as PropType<string>,
      default: ''
    },
    id: {
      type: String as PropType<string>,
      default: ''
    },
    name: {
      type: String as PropType<string>,
      default: ''
    },
    inputClass: {
      type: String as PropType<string>,
      default: ''
    },
    iconClass: {
      type: String as PropType<string>,
      default: ''
    },
    value: {
      type: [String, Number] as PropType<string|number>,
      default: ''
    },
    msgError: {
      type: String as PropType<string>,
      default: ''
    },
    hasError: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    min: {
      type: String as PropType<string>,
      default: ''
    },
    max: {
      type: String as PropType<string>,
      default: ''
    },
    step: {
      type: String as PropType<string>,
      default: ''
    },
    maxlength: {
      type: Number as PropType<number|null>,
      default: null
    },
    prepend: {
      type: String
    },
    append: {
      type: String
    }
  }
})
